import { useMemo } from 'react'

export const useAdminAuthSlice = <
  TLoginForm,
  TSetLoginForm,
  TLoginStage,
  TSetLoginStage,
  THandleLogin,
  TLogout,
>({
  isAuthenticated,
  requiresDeviceTrust,
  setRequiresDeviceTrust,
  authLoading,
  sessionBootstrapLoading,
  loginForm,
  setLoginForm,
  loginStage,
  setLoginStage,
  handleLogin,
  token,
  logout,
}: {
  isAuthenticated: boolean
  requiresDeviceTrust: boolean
  setRequiresDeviceTrust: (next: boolean) => void
  authLoading: boolean
  sessionBootstrapLoading: boolean
  loginForm: TLoginForm
  setLoginForm: TSetLoginForm
  loginStage: TLoginStage
  setLoginStage: TSetLoginStage
  handleLogin: THandleLogin
  token: string | null
  logout: TLogout
}) =>
  useMemo(
    () => ({
      isAuthenticated,
      requiresDeviceTrust,
      setRequiresDeviceTrust,
      authLoading,
      sessionBootstrapLoading,
      loginForm,
      setLoginForm,
      loginStage,
      setLoginStage,
      handleLogin,
      token,
      logout,
    }),
    [
      authLoading,
      handleLogin,
      isAuthenticated,
      loginStage,
      loginForm,
      logout,
      requiresDeviceTrust,
      sessionBootstrapLoading,
      setLoginForm,
      setLoginStage,
      setRequiresDeviceTrust,
      token,
    ],
  )
